import { render, staticRenderFns } from "./Division.vue?vue&type=template&id=1f4e47b0&scoped=true&"
import script from "./Division.vue?vue&type=script&lang=ts&"
export * from "./Division.vue?vue&type=script&lang=ts&"
import style0 from "./Division.vue?vue&type=style&index=0&id=1f4e47b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e47b0",
  null
  
)

export default component.exports